function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling?.id) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    const details = event.currentTarget.closest('details');
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (this.input.value < 1) {
      event.target.name === 'minus' ? event.target.classList.add('disabled') : {};
      this.input.classList.add('disabled');
      this.input.stepUp();
    } else {
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.debounce = debounce;

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.body = document.querySelector('body');
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    this.facets = this.classList.contains('facets_parent');
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button.menu-drawer__close-button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('.mobile-facets__close').forEach((closeButton) => {
      closeButton.addEventListener('click', this.onMobileFacetsCloseClick.bind(this));
    });
    this.querySelectorAll('button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.mobile-facets__close)').forEach((button) => {
      // Keep mobile drawer open while interacting with city/language selectors.
      if (button.closest('localization-form') || button.closest('.mobile-menu')) return;
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  connectedCallback() {
    this.bindViewportSync();
  }

  disconnectedCallback() {
    this.desktopMedia?.removeEventListener('change', this.onViewportChange);
    this.viewportSyncBound = false;
  }

  get desktopMediaQuery() {
    // Matches the overflow-hidden-* breakpoints in base.css and when header-drawer is hidden.
    return this.dataset.breakpoint === 'mobile' ? '(min-width: 769px)' : '(min-width: 990px)';
  }

  bindViewportSync() {
    if (this.viewportSyncBound) return;
    this.viewportSyncBound = true;
    this.onViewportChange = this.onViewportChange.bind(this);
    this.desktopMedia = window.matchMedia(this.desktopMediaQuery);
    this.desktopMedia.addEventListener('change', this.onViewportChange);
    if (this.desktopMedia.matches) this.releaseDrawerForViewport();
  }

  onViewportChange(event) {
    if (event.matches) this.releaseDrawerForViewport();
  }

  isDrawerLockingPage() {
    const lockClass = this.facets ? 'facets-open' : 'menu-open';
    return Boolean(
      this.mainDetailsToggle?.hasAttribute('open') ||
      this.mainDetailsToggle?.classList.contains('menu-opening') ||
      this.body?.classList.contains(lockClass) ||
      document.body.classList.contains(`overflow-hidden-${this.dataset.breakpoint}`)
    );
  }

  releaseDrawerForViewport() {
    if (!this.isDrawerLockingPage()) return;

    const summary = this.mainDetailsToggle?.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    if (typeof this.closeMobileSearchDrawer === 'function') this.closeMobileSearchDrawer();

    this.mainDetailsToggle?.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle?.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });

    this.clearDrawerScrollLock();
  }

  clearDrawerScrollLock() {
    const lockClass = this.facets ? 'facets-open' : 'menu-open';
    document.body.classList.remove(lockClass, `overflow-hidden-${this.dataset.breakpoint}`);
    this.mainDetailsToggle?.classList.remove('menu-opening');
    this.mainDetailsToggle?.removeAttribute('open');
    document.getElementById('shopify-section-header')?.classList.remove('menu-open');
    removeTrapFocus();
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    if (summaryElement.closest('.mobile-menu')) return;

    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const isMobileFacetsDetails = detailsElement.hasAttribute('data-facets-disclouser-mobile')

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (isMobileFacetsDetails) return

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    this.body.classList.add(this.facets ? 'facets-open' : 'menu-open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.body.classList.remove(this.facets ? 'facets-open' : 'menu-open');
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  onMobileFacetsCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const summaryElement = this.mainDetailsToggle?.querySelector('summary');
    if (!summaryElement) return;
    this.closeMenuDrawer(event, summaryElement);
  }


  closeSubmenu(detailsElement) {
    if (!detailsElement) return;

    const parentMenuElement = detailsElement.closest('.submenu-open');
    if (parentMenuElement) {
      parentMenuElement.classList.remove('submenu-open');
    }

    detailsElement.classList.remove('menu-opening');
    const summary = detailsElement.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', false);
      removeTrapFocus(summary);
    }

    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  /** Mobile search (#search-drawer) is toggled outside MenuDrawer; close it when opening the nav menu. */
  closeMobileSearchDrawer() {
    const searchDrawer = document.getElementById('search-drawer');
    if (!searchDrawer || !searchDrawer.classList.contains('is-open')) return;
    searchDrawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }

  openMenuDrawer(summaryElement) {
    this.closeMobileSearchDrawer();
    this.body.classList.add('menu-open');
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    this.header = this.header || document.getElementById('shopify-section-header');
    super.closeMenuDrawer(event, elementToFocus);
    this.header?.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
window.ModalDialog = ModalDialog;
customElements.define('modal-dialog', ModalDialog);
document.dispatchEvent(new CustomEvent('twinkle:modal-ready'));

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', (event) => {
      const isMobileZoom =
        window.matchMedia('(max-width: 768px)').matches &&
        this.dataset.mobileZoom === 'true' &&
        this.classList.contains('product__modal-opener--image');

      if (isMobileZoom) return;

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.initMobileSwipe();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    // Thumbnail gallery arrows navigate active media, not overflow scroll.
    if (this.classList.contains('thumbnail-slider')) return;
    if (!this.prevButton || !this.nextButton || !this.sliderItemsToShow?.length) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  getVisibleSibling(element, direction) {
    let sibling = direction === 'next' ? element?.nextElementSibling : element?.previousElementSibling;
    while (sibling) {
      if (window.getComputedStyle(sibling).display !== 'none') return sibling;
      sibling = direction === 'next' ? sibling.nextElementSibling : sibling.previousElementSibling;
    }
    return null;
  }

  updateThumbnailNavButtons(mediaGallery) {
    if (!mediaGallery) return;

    const currentThumb = mediaGallery.querySelector('.thumb-slider-thumbnail-btn[aria-current="true"]');
    const thumbnailSlider = mediaGallery.querySelector('slider-component.thumbnail-slider');
    if (!currentThumb || !thumbnailSlider) return;

    const currentListItem = currentThumb.closest('.thumbnail-list__item') || currentThumb.parentElement;
    const hasPrev = !!this.getVisibleSibling(currentListItem, 'previous');
    const hasNext = !!this.getVisibleSibling(currentListItem, 'next');
    const prevButton = thumbnailSlider.querySelector('.slider-button[name="previous"]');
    const nextButton = thumbnailSlider.querySelector('.slider-button[name="next"]');

    if (prevButton) {
      if (hasPrev) prevButton.removeAttribute('disabled');
      else prevButton.setAttribute('disabled', true);
    }

    if (nextButton) {
      if (hasNext) nextButton.removeAttribute('disabled');
      else nextButton.setAttribute('disabled', true);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });

    const mediaGallery = this.closest('media-gallery');
    if (!mediaGallery) return;

    const currentThumb = mediaGallery.querySelector('.thumb-slider-thumbnail-btn[aria-current="true"]');
    if (!currentThumb) return;

    const currentListItem = currentThumb.closest('.thumbnail-list__item') || currentThumb.parentElement;
    const clickThumb = new Event('click');

    if (event.currentTarget.name === 'next') {
      const nextListItem = this.getVisibleSibling(currentListItem, 'next');
      if (!nextListItem) {
        this.updateThumbnailNavButtons(mediaGallery);
        return;
      }

      const nextThumb = nextListItem.querySelector('.thumb-slider-thumbnail-btn');
      if (!nextThumb) return;

      currentThumb.removeAttribute('aria-current');
      nextThumb.setAttribute('aria-current', 'true');
      nextThumb.dispatchEvent(clickThumb);
    } else {
      const prevListItem = this.getVisibleSibling(currentListItem, 'previous');
      if (!prevListItem) {
        this.updateThumbnailNavButtons(mediaGallery);
        return;
      }

      const prevThumb = prevListItem.querySelector('.thumb-slider-thumbnail-btn');
      if (!prevThumb) return;

      currentThumb.removeAttribute('aria-current');
      prevThumb.setAttribute('aria-current', 'true');
      prevThumb.dispatchEvent(clickThumb);
    }

    this.updateThumbnailNavButtons(mediaGallery);
  }

  
  initMobileSwipe() {
    if (!this.classList.contains('slider-mobile-gutter') || !this.classList.contains('slider-mobile-gutter-images')) return;

    const mobileQuery = window.matchMedia('(max-width: 768px)');
    let touchStartX = 0;
    let touchStartY = 0;
    this.slider.style.touchAction = 'pan-y';
    this.slider.style.overscrollBehaviorX = 'contain';

    const isMediaZoomBlockingSwipe = () => {
      return this.classList.contains('media-zoom-active') ||
        !!this.querySelector('.product__modal-opener--mobile-zoom.is-zoomed');
    };

    const onTouchStart = (event) => {
      if (!mobileQuery.matches || !event.touches || !event.touches.length) return;
      if (isMediaZoomBlockingSwipe()) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    };

    const onTouchMove = (event) => {
      if (!mobileQuery.matches || !event.touches || !event.touches.length) return;
      if (isMediaZoomBlockingSwipe()) return;
      const deltaX = event.touches[0].clientX - touchStartX;
      const deltaY = event.touches[0].clientY - touchStartY;
      if (Math.abs(deltaX) > Math.abs(deltaY)) event.preventDefault();
    };

    const onTouchEnd = (event) => {
      if (!mobileQuery.matches || !event.changedTouches || !event.changedTouches.length) return;
      if (isMediaZoomBlockingSwipe()) return;

      const mediaGallery = this.closest('media-gallery');
      const galleryMediaSize = mediaGallery ? parseInt(mediaGallery.dataset.mediaSize, 10) : NaN;
      const totalSlides = Number.isFinite(galleryMediaSize) ? galleryMediaSize : (this.sliderItems ? this.sliderItems.length : 0);
      if (totalSlides <= 1) return;

      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      const minSwipeDistance = 40;

      if (Math.abs(deltaX) < minSwipeDistance || Math.abs(deltaX) <= Math.abs(deltaY)) return;

      const directionButton = deltaX < 0 ? this.nextButton : this.prevButton;
      if (!directionButton) return;
      this.onButtonClick({
        preventDefault: () => { },
        currentTarget: directionButton
      });
    };

    this.slider.addEventListener('touchstart', onTouchStart, { passive: true });
    this.slider.addEventListener('touchmove', onTouchMove, { passive: false });
    this.slider.addEventListener('touchend', onTouchEnd, { passive: true });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

function convertToArabicNumbers(input) {
  const englishToArabic = {
    '0': '٠',
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '.': '٫'
  };

  return input.replace(/[0-9.]/g, (char) => englishToArabic[char] || char);
}

function updateAddToCartButton(TotalPrice, origin = null) {
  let buttons = [];
  const stickyATCText = document.querySelector('sticky-atc .product-sticky-atc .add_to_cart-sold_out_btn');

  if (origin && origin instanceof HTMLElement) {
    const container = origin.closest('.shopify-section') || origin.closest('.product') || origin.closest('.grid__item');
    if (container) {
      buttons = Array.from(container.querySelectorAll('[name="add"], [name="update"]'));
    }
    // Also include sticky ATC if the container seems to be the main product section
    if (container && (container.id.includes('main') || container.className.includes('main-product'))) {
      if (stickyATCText) {
        const stickyButton = stickyATCText.closest('button');
        if (stickyButton && !buttons.includes(stickyButton)) buttons.push(stickyButton);
      }
    }
  }

  if (buttons.length === 0) {
    buttons = Array.from(document.querySelectorAll('[name="add"], [name="update"]'));
  }

  const pathMatch = window.location.pathname.match(/\/products\/(.*)$/);
  const handle = pathMatch ? pathMatch[1] : null;

  const isEditing = localStorage.getItem('edit-product-handle') === handle;

  buttons.forEach(button => {
    button.removeAttribute('disabled');
    button.classList.remove('sold-out');

    const textSpan = button.querySelector('.add_to_cart-sold_out_btn') || button.querySelector('span');
    if (textSpan) {
      const isUpdateButton = isEditing;
      const btnLabel = isUpdateButton ? window.variantStrings.updateCart : window.variantStrings.addToCart;

      const priceComponent = textSpan.querySelector('.price-component');
      if (priceComponent) {
        if (textSpan.childNodes.length > 0 && textSpan.childNodes[0].nodeType === 3) {
          textSpan.childNodes[0].textContent = btnLabel + ' — ';
        } else {
          textSpan.innerHTML = btnLabel + ' — <span class="price-component">' + TotalPrice + '</span>';
          return;
        }
        priceComponent.textContent = TotalPrice;
      } else {
        textSpan.textContent = btnLabel + ' — ' + TotalPrice;
      }
    }
  });

  if (stickyATCText) {
    const isUpdateButton = isEditing;
    const btnLabel = isUpdateButton ? window.variantStrings.updateCart : window.variantStrings.addToCart;
    stickyATCText.textContent = btnLabel + ' — ' + TotalPrice;
  }
}

function getFormattedPrice(totalPrice) {
  if (Shopify.locale === 'ar') {
    const price = parseInt(totalPrice / 100);
    return convertToArabicNumbers(price.toString()) + ' ر.س';
  } else {
    return Shopify.formatMoney(totalPrice);
  }
}

// Remove global price variables
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);

    this.addEventListener('change', this.onVariantChange);
    window.addEventListener('load', () => {
      this.onVariantChange();
    });
  }

  onVariantChange() {
    this.updatelocalStorage();
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateOptionState();

    if (!this.currentVariant) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, window.variantStrings.addToCart);
      document.querySelectorAll(`.productvariant_names li`).forEach(li => {
        li.classList.add('d-none');
      });

      this.options.map(option => {
        if (document.querySelector(`.productvariant_names li[data-option='${option}']`) && this.options[0] == option) {
          document.querySelector(`.productvariant_names li[data-option='${option}']`).classList.remove('d-none');
        } else {
          document.querySelector(`.productvariant_names li[data-option='${option}']`)
        }
      });

      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.firstOptionSelect();

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: this.currentVariant, target: this }
      }))
    }
  }

  updatelocalStorage() {
    Shopify.theme.cart.getState().then(async (res) => {
      const carthandle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
      if (!carthandle || !res?.items?.length) {
        this.removelocalStorage();
        return;
      }

      let found = false;
      res.items.forEach((item, index) => {
        if (item.handle === carthandle) {
          found = true;
          localStorage.setItem('edit-product', item.id);
          localStorage.setItem('edit-product-index', index);
          localStorage.setItem('edit-product-handle', item.handle);
          localStorage.setItem('edit-product-key', item.key);
        }
      });

      if (!found) {
        this.removelocalStorage();
      }
    });
  }

  removelocalStorage() {
    localStorage.removeItem('edit-product');
    localStorage.removeItem('edit-product-index');
    localStorage.removeItem('edit-product-handle');
    localStorage.removeItem('edit-product-key');
  }

  updateOptions() {
    return this.options = Array.from(this.querySelectorAll('select'), (select) => { select.value });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    if (mediaGalleries.length && Array.from(mediaGalleries).every((gallery) => gallery.dataset.arImages === 'true')) {
      this.updateArVariantMedia(mediaGalleries);
      return;
    }

    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const asso_images = this.getAssociatedImages() || [];

    mediaGalleries.forEach(mediaGallery => {
      if (asso_images.length) {
        mediaGallery.setActiveMedia(
          asso_images.map(id => `${this.dataset.section}-${id}`),
          false,
          null,
          true
        );
      }

      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
        this.currentVariant.featured_media.position,
        false
      );
    });

    const src = this.currentVariant.featured_media.preview_image.src;
    document.querySelector('sticky-atc img')?.setAttribute('src', src);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      if (newMediaModal) modalContent.prepend(newMediaModal);
    }
  }

  updateArVariantMedia(mediaGalleries) {
    if (!this.currentVariant) return;

    let image = null;
    const dataEl = document.getElementById(`ArVariantImages-${this.dataset.section}`);
    if (dataEl) {
      try {
        const imagesByVariant = JSON.parse(dataEl.textContent);
        image = imagesByVariant[String(this.currentVariant.id)];
      } catch (e) {
        image = null;
      }
    }

    const associatedImages = this.getAssociatedImages() || [];
    const hasVariantImage = image && image.id != null && image.id !== '';

    mediaGalleries.forEach((mediaGallery) => {
      if (typeof mediaGallery.setActiveMedia !== 'function') return;

      if (associatedImages.length) {
        mediaGallery.setActiveMedia(
          associatedImages.map((id) => `${this.dataset.section}-${id}`),
          false,
          null,
          true
        );
      }

      if (hasVariantImage) {
        mediaGallery.setActiveMedia(`${this.dataset.section}-ar-${image.id}`, true, null, false);
      }
    });

    if (!hasVariantImage) return;

    if (image.src) {
      document.querySelector('sticky-atc img')?.setAttribute('src', image.src);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;

    const newMediaModal = modalContent.querySelector(`[data-media-id="${image.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }


  getAssociatedImages() {
    const checked = this.querySelector('input[type="radio"]:checked');
    if (!checked) return [];
    const label = this.querySelector(`label[for="${checked.id}"]`);
    if (!label) return [];
    const attr = label.getAttribute('data-associated-images');
    try {
      return attr ? JSON.parse(attr) : [];
    } catch (e) {
      console.warn("Invalid data-associated-images:", attr);
      return [];
    }
  }

  firstOptionSelect() {
    const _this = this;
    _this.updateMedia();
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const variants = this.getVariantData();
    const currentOptions = this.currentVariant?.options || [];

    const isNoneOption = (value) => {
      const normalized = (value || '').trim().toLowerCase();
      return ['none', 'لا أحد', 'لا شيء', 'لا شئ', 'بدون'].includes(normalized);
    };

    const formatOptionExtraPrice = (amount) => {
      const formatted = getFormattedPrice(Math.abs(amount));
      if (amount > 0) return `+ ${formatted}`;
      if (amount < 0) return `- ${formatted}`;
      return formatted;
    };

    const updateCustomizeOptionPrices = () => {
      const partySize = currentOptions[0];
      if (!partySize) return;

      const partyVariants = variants.filter((variant) => variant.options?.[0] === partySize);
      if (!partyVariants.length) return;

      const baseVariant =
        partyVariants.find((variant) => variant.options.slice(1).every(isNoneOption)) ||
        partyVariants.reduce((cheapest, variant) => {
          if (!cheapest || variant.price < cheapest.price) return variant;
          return cheapest;
        }, null);

      if (!baseVariant) return;

      document.querySelectorAll('.customize-wrapper .product-option-selector').forEach((option) => {
        const optionValue = option.dataset.value;
        const optionPosition = Number(option.dataset.optionPosition);
        const priceSpan = option.querySelector('.option_price');
        if (!priceSpan || !optionValue || isNoneOption(optionValue) || !optionPosition) return;

        const matchingVariant = partyVariants.find((variant) => {
          return variant.options.every((opt, index) => {
            if (index === optionPosition - 1) return opt === optionValue;
            return opt === currentOptions[index];
          });
        }) || partyVariants.find((variant) => variant.options[optionPosition - 1] === optionValue);

        if (!matchingVariant) return;

        const difference = matchingVariant.price - baseVariant.price;
        priceSpan.dataset.value = difference;
        if (difference === 0) {
          priceSpan.classList.add('hidden');
          priceSpan.innerHTML = '';
          return;
        }

        priceSpan.classList.remove('hidden');
        priceSpan.innerHTML = formatOptionExtraPrice(difference);
      });
    };

    if (document.querySelector('.customize-wrapper .product-option-selector .option_price')) {
      updateCustomizeOptionPrices();
    }

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }



  updateOptionState() {
    const options = document.querySelectorAll('.product-option-selector');
    const variants = this.getVariantData();
    const currentVariant = this.currentVariant;

    options.forEach((option) => {
      const optionIndex = option.dataset.optionPosition;
      const optionValue = option.dataset.value;
      const currentVariantOptions = [...currentVariant.options];

      currentVariantOptions[Number(optionIndex) - 1] = optionValue;

      const variantWithCurrentOption = variants.find((variant) => variant.title === currentVariantOptions.join(' / '));

      if (variantWithCurrentOption.available) {
        option.classList.remove('unavailable-varinat');
      } else {
        option.classList.add('unavailable-varinat');
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    let section = this.dataset.originalSection || this.dataset.section;
    let variantId = this.currentVariant.id;
    let url = `${this.dataset.url}?variant=${variantId}&section_id=${section}`;

    this.lastRequestedVariantId = variantId;

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        if (this.lastRequestedVariantId !== variantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (destination) destination.classList.remove('visibility-hidden');

        const addonDest = document.getElementById(`addon-items-${this.dataset.section}`);
        const addonSrc = html.getElementById(`addon-items-${section}`);
        if (addonDest && addonSrc) {
          addonDest.replaceWith(addonSrc);
        }

        const fieldsDest = document.getElementById(`addon-form-fields-${this.dataset.section}`);
        const fieldsSrc = html.getElementById(`addon-form-fields-${section}`);
        if (fieldsDest && fieldsSrc) {
          fieldsDest.replaceWith(fieldsSrc);
        }

        const customizationProduct =
          document.querySelector(`#addon-items-${this.dataset.section}`)?.closest('.product__info-wrapper')?.querySelector('customization-product') ||
          document.querySelector('customization-product');
        if (customizationProduct && this.currentVariant) {
          customizationProduct.mainPrice = this.currentVariant.price;
          customizationProduct.recalculateAdditionalPrice?.();
          customizationProduct.updateTotalPrice?.();
          customizationProduct.syncAllQtyButtonStates?.();
        }
      });
  }

  toggleAddButton(disable = false, text) {
    if (this.currentVariant) {
      const custComp = this.closest('section')?.querySelector('customization-product');
      let combinedPrice = this.currentVariant.price;
      if (custComp) {
        custComp.mainPrice = this.currentVariant.price;
        custComp.recalculateAdditionalPrice?.();
        combinedPrice = this.currentVariant.price + (custComp.additionalPrice || 0);
      }
      let currentVariantPrice = getFormattedPrice(combinedPrice);

      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      if (disable) {
        const addButton = productForm.querySelector('[name="add"]');
        const secondaryATC = document.querySelector('.customize-wrapper [name="add"]');
        const stickyATCText = document.querySelector('sticky-atc .product-sticky-atc .add_to_cart-sold_out_btn');

        if (!addButton) return;

        addButton.disabled = true;
        addButton.classList.add("sold-out");
        if (secondaryATC) {
          secondaryATC.disabled = true;
        }

        if (text) {
          text = text + ' — ' + currentVariantPrice;
          const addButtonText = addButton.querySelector('span');
          const secondaryATCText = secondaryATC ? secondaryATC.querySelector('span') : null;
          if (addButtonText) addButtonText.textContent = text;
          if (secondaryATCText) secondaryATCText.textContent = text;
          if (stickyATCText) stickyATCText.textContent = text;
        }
      } else {
        updateAddToCartButton(currentVariantPrice, this);
      }

      document.querySelector('localization-form')?.changePDPbtn();
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    addButton.classList.add('disabled');
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const template = document.querySelector('.template-main-product-kids') ||
      document.querySelector('.main_new-main-product') ||
      document.querySelector('.template-product-bundle-gift') ||
      document.querySelector('.template-cake-balloon');
    if (template) {
      const customizeWrapper = document.querySelector('.customize-wrapper');
      if (!customizeWrapper) return;

      const optionsWrappers = customizeWrapper.querySelectorAll('.options-wrapper');
      if (optionsWrappers.length === 0) return;

      const optionsWrapper1 = optionsWrappers[0];
      const optionsWrapper2 = optionsWrappers.length > 1 ? optionsWrappers[1] : optionsWrapper1;

      let option2 = optionsWrapper2.querySelector('.product-option-selector') || optionsWrapper1.querySelector('.product-option-selector');

      if (option2) {
        const clickEvt = new Event('click');
      }
    }
  }, 500);
});

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  onVariantChange() {
    super.onVariantChange();
    this.updateSwatchLabels();
  }

  updateSwatchLabels() {
    this.querySelectorAll('.product-form__input--swatch').forEach((fieldset) => {
      const legend = fieldset.querySelector('[data-swatch-legend]');
      const textEl = fieldset.querySelector('.product__swatch-legend-text');
      if (!legend || !textEl) return;

      const optionLabel = legend.dataset.optionLabel;
      const checked = fieldset.querySelector('input[type="radio"]:checked:not(.hidden)');

      if (checked?.value) {
        textEl.textContent = `${optionLabel} - ${checked.value}`;
      } else {
        textEl.textContent = optionLabel;
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const selects = Array.from(this.querySelectorAll('.select'));
    if (selects.length) {
      let select_options = selects.map((select) => {
        let _selects = Array.from(select.querySelectorAll('option'));
        return _selects.find((option) => option.selected)?.value;
      }).filter((value) => value != null);
      fieldsets.forEach((select) => {
        select_options.forEach(option => {
          if (select.querySelector(`input[value="${option}"]`) != null) {
            select.querySelector(`input[value="${option}"]`).checked = true;
          }
        })
      })
    }
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      let checked = inputs.find((radio) => radio.checked);

      // Include-cake off can leave secondary options with no checked radio
      if (!checked) {
        const isNone = (radio) => {
          const value = (radio.value || '').trim().toLowerCase();
          return value === 'none' || value === 'nothing' || value === 'لا أحد';
        };
        checked = inputs.find(isNone) || inputs[0];
        if (checked) checked.checked = true;
      }

      return checked?.value;
    });
  }

  triggerOptionChange(optionName, optionValue) {
    this.querySelector(`input[name="${optionName}"][value="${optionValue}"]`).click();
  }
}

customElements.define('variant-radios', VariantRadios);

class DynamicDescription extends HTMLElement {
  connectedCallback() {
    this.onVariantChange = this.onVariantChange.bind(this)
    document.addEventListener('variant:change', this.onVariantChange)
    this.syncFromSelectedVariant()
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.onVariantChange)
  }

  onVariantChange(event) {
    const variant = event.detail && event.detail.variant
    if (!variant) return

    const source = event.detail.target
    const root = this.productRoot()
    if (source) {
      if (root && !root.contains(source)) return
    } else if (!this.ownsVariant(variant.id)) {
      return
    }

    this.applyVariant(variant.id)
  }

  productRoot() {
    return this.closest('.product') || this.closest('[data-modal-content]')
  }

  selectedVariantId() {
    const root = this.productRoot()
    if (!root) return ''
    const input = root.querySelector('product-form input[name="id"]') || root.querySelector('input[name="id"]')
    return input && input.value ? String(input.value) : ''
  }

  ownsVariant(id) {
    const variantId = String(id)
    return Array.from(this.querySelectorAll('.variant_description')).some(
      (item) => item.dataset.variantId === variantId
    )
  }

  variantBelongsToProduct(id) {
    const root = this.productRoot()
    const picker = root && root.querySelector('variant-radios, variant-selects')
    const dataEl = picker && picker.querySelector('[type="application/json"]')
    if (!dataEl) return false

    try {
      const variants = JSON.parse(dataEl.textContent)
      return variants.some((variant) => String(variant.id) === String(id))
    } catch (error) {
      return false
    }
  }

  syncFromSelectedVariant() {
    const root = this.productRoot()
    const picker = root && root.querySelector('variant-radios, variant-selects')
    if (picker && picker.currentVariant) {
      this.applyVariant(picker.currentVariant.id)
      return
    }

    const id = this.selectedVariantId()
    if (id) this.applyVariant(id)
  }

  applyVariant(id) {
    const variantId = String(id)
    const descriptions = this.querySelectorAll('.variant_description')
    const hasMatch = Array.from(descriptions).some((item) => item.dataset.variantId === variantId)

    if (!hasMatch) {
      if (!this.variantBelongsToProduct(variantId)) return
      descriptions.forEach((item) => item.classList.add('hidden'))
      return
    }

    descriptions.forEach((item) => {
      item.classList.toggle('hidden', item.dataset.variantId !== variantId)
    })
  }
}

customElements.define('dynamic-description', DynamicDescription);

const REQUIRED_NUMBER_PROPERTY_NAMES = new Set(['number', 'رقم', 'الرقم']);

function lineItemDigitsOnly(value) {
  return String(value == null ? '' : value)
    .replace(/[\u0660-\u0669]/g, (ch) => String(ch.charCodeAt(0) - 0x0660))
    .replace(/[\u06F0-\u06F9]/g, (ch) => String(ch.charCodeAt(0) - 0x06F0))
    .replace(/[\uFF10-\uFF19]/g, (ch) => String(ch.charCodeAt(0) - 0xFF10))
    .replace(/\D/g, '');
}

function isRequiredNumberPropertyInput(input) {
  if (!input || input.dataset.isRequired !== 'true') return false;
  if (input.hasAttribute('data-numeric-only')) return true;
  const key = (input.dataset.name || '').trim().toLowerCase();
  return REQUIRED_NUMBER_PROPERTY_NAMES.has(key);
}

function restrictLineItemInputToDigits(input) {
  const raw = input.value;
  const cleaned = lineItemDigitsOnly(raw);
  if (cleaned === raw) return;

  let start = null;
  try {
    start = input.selectionStart;
  } catch (e) {
    start = null;
  }

  const caret = start == null ? cleaned.length : lineItemDigitsOnly(raw.slice(0, start)).length;
  input.value = cleaned;
  if (start != null && typeof input.setSelectionRange === 'function') {
    const pos = Math.min(caret, cleaned.length);
    input.setSelectionRange(pos, pos);
  }
}

window.TwinkleLineItemDigits = {
  digitsOnly: lineItemDigitsOnly,
  isRequiredNumberField: isRequiredNumberPropertyInput,
};

class CustomizationProduct extends HTMLElement {
  constructor() {
    super();
    this.mainPrice = 0;
    this.additionalPrice = 0;
    //this.init();
  }
  connectedCallback() {
    this.init();
  }

  init() {
     if (this.initialized) return;
    this.initialized = true;
    this.initQtyButtons();
    this.initInputNumberFields();
    this.initOptionToggles();
    this.initOptionWrappers();
    this.initLineItemInputs();
    this.initGenderSelector();
    this.syncAllQtyButtonStates();
  }

  productScope() {
    return this.closest('.product__info-container') || this.closest('.product__info-wrapper') || this;
  }

  productForm() {
    return this.querySelector('form') || this.productScope().querySelector('product-form form.form');
  }

  getSiblings(elem) {
    return Array.from(elem.parentNode?.children || []).filter(child => child !== elem);
  }

  setFormInput(option) {
    const name = option.dataset.name;
    const value = option.dataset.value;
    this.closest('.product__info-wrapper')?.querySelector('variant-radios')?.triggerOptionChange(name, value);
  }

  updateInputs(toggle) {
    if (!toggle) return;

    const wrapper = toggle.closest('.switch-wrapper')?.nextElementSibling;
    const isChecked = toggle.checked;
    if (!wrapper) return;

    if (isChecked) {
      this.showWrapperAndSelectDefault(wrapper);
      this.autoSelectForCity(wrapper);
    } else {
      this.hideWrapperAndReset(wrapper);
    }
  }

  showWrapperAndSelectDefault(wrapper) {
    wrapper.classList.remove('hidden');
    const defaults = wrapper.querySelectorAll('[data-default]');
    defaults.forEach(option => {
      option.classList.add('checked');
      this.setFormInput(option);
    });
  }

  autoSelectForCity(wrapper) {
    const city = (localStorage.getItem('selectedCity') || '').trim().toUpperCase();
    if (city !== 'RIYADH' && city !== 'JEDDAH') return;

    const optionWrappers = wrapper.querySelectorAll('.options-wrapper');
    if (!optionWrappers.length) return;

    const option1 = optionWrappers[0]?.querySelectorAll('.product-option-selector')[1];
    const option2 = optionWrappers.length >= 2 ? optionWrappers[1]?.querySelectorAll('.product-option-selector')[2] : optionWrappers[0]?.querySelectorAll('.product-option-selector')[0];

    const event = new Event('click');
    [option1, option2].forEach(option => {
      if (option) {
        option.dispatchEvent(event);
        option.classList.add('checked');
        this.setFormInput(option);
      }
    });
  }

  hideWrapperAndReset(wrapper) {
    wrapper.classList.add('hidden');
    const options = wrapper.querySelectorAll('.product-option-selector');
    options.forEach(option => {
      if (['none', 'nothing', 'لا أحد'].includes((option.dataset.value || '').trim().toLowerCase())) {
        option.classList.add('checked');
        this.setFormInput(option);
      } else {
        option.classList.remove('checked');
      }
    });

    if (wrapper.classList.contains('addon_product_container')) {
      const inputs = wrapper.querySelectorAll('input[type="text"], input[type="number"]');
      const mainForm = this.productForm();
      inputs.forEach(input => {
        const matchingInput = mainForm?.querySelector(`input[name="${input.name}"]`);
        const accessoriesInput = mainForm?.querySelector(`input[name="properties[Accessories][${input.dataset.handle}]"]`);
        if (matchingInput) {
          matchingInput.value = `${input.dataset.variant}:0`;
          if (accessoriesInput) accessoriesInput.value = 0;
        }
        input.value = 0;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      this.recalculateAdditionalPrice();
      this.updateTotalPrice();
    }
  }

  updateTotalPrice() {
    const total = (this.mainPrice || 0) + (this.additionalPrice || 0);
    updateAddToCartButton(getFormattedPrice(total), this);
  }

  recalculateAdditionalPrice() {
    let total = 0;
    this.productScope().querySelectorAll('input.input-number[name^="properties[_pdp_addon_"]').forEach((input) => {
      const qty = parseInt(input.value, 10) || 0;
      const price = parseInt(input.dataset.price, 10) || 0;
      total += qty * price;
    });
    this.additionalPrice = total;
  }

  syncQtyButtonStateForInput(input) {
    if (!input?.classList?.contains('input-number')) return;

    const minValue = parseInt(input.getAttribute('min'), 10);
    const maxValue = parseInt(input.getAttribute('max'), 10);
    let valueCurrent = parseInt(input.value, 10);
    const name = input.getAttribute('name');
    if (!name || isNaN(minValue) || isNaN(maxValue)) return;
    const scope = this.productScope();

    if (isNaN(valueCurrent)) {
      valueCurrent = minValue;
      input.value = minValue;
    }

    const minusBtn = scope.querySelector(`.btn-number[data-type='minus'][data-field='${name}']`);
    const plusBtn = scope.querySelector(`.btn-number[data-type='plus'][data-field='${name}']`);
    const modalPlusBtn = scope.querySelector(`.btn-number[data-type='modal-plus'][data-field='${name}']`);

    if (valueCurrent <= minValue) {
      minusBtn?.setAttribute('disabled', true);
    } else {
      minusBtn?.removeAttribute('disabled');
    }

    if (valueCurrent >= maxValue) {
      plusBtn?.setAttribute('disabled', true);
      modalPlusBtn?.setAttribute('disabled', true);
    } else {
      plusBtn?.removeAttribute('disabled');
      modalPlusBtn?.removeAttribute('disabled');
    }
  }

  syncAllQtyButtonStates() {
    this.productScope().querySelectorAll('.input-number').forEach((input) => this.syncQtyButtonStateForInput(input));
  }

  handleQtyButtonClick(button) {
    if (!(button instanceof HTMLElement) || !button.classList.contains('btn-number')) return;
    if (button.getAttribute('data-type') === 'modal-plus') return;

    const fieldName = button.getAttribute('data-field');
    const type = button.getAttribute('data-type');
    const scope = this.productScope();
    const form = this.productForm();
    const input = scope.querySelector(`input.input-number[name='${fieldName}']`);
    const hiddenInput = form?.querySelector(`input[type="hidden"][name='${fieldName}']`);
    if (!input) return;

    const currentVal = parseInt(input.value, 10);
    const variant_id = input.dataset.variant;
    const handle = input.dataset.handle;
    const accessories_input = form?.querySelector(`input[name="properties[Accessories][${handle}]"]`);

    if (!isNaN(currentVal)) {
      if (type === 'minus') {
        const plusBtn = button.closest('.input-group')?.querySelector('button[data-type="plus"]');
        if (currentVal > input.getAttribute('min')) {
          const nextVal = currentVal - 1;
          input.value = nextVal;
          input.dataset.oldValue = String(nextVal);
          if (hiddenInput) hiddenInput.value = `${variant_id}:${nextVal}`;
          if (accessories_input) accessories_input.value = nextVal;
          plusBtn?.removeAttribute('disabled');
        }
        if (parseInt(input.value, 10) == input.getAttribute('min')) {
          button.setAttribute('disabled', true);
          plusBtn?.removeAttribute('disabled');
        }
      } else if (type === 'plus') {
        const minusBtn = button.closest('.input-group')?.querySelector('button[data-type="minus"]');
        if (currentVal < input.getAttribute('max')) {
          const nextVal = currentVal + 1;
          input.value = nextVal;
          input.dataset.oldValue = String(nextVal);
          if (hiddenInput) hiddenInput.value = `${variant_id}:${nextVal}`;
          if (accessories_input) accessories_input.value = nextVal;
        }
        if (currentVal > input.getAttribute('min') || currentVal < input.getAttribute('max')) {
          minusBtn?.removeAttribute('disabled');
        }
        if (parseInt(input.value, 10) == input.getAttribute('max')) {
          button.setAttribute('disabled', true);
          minusBtn?.removeAttribute('disabled');
        }
      }
    } else {
      if (hiddenInput) hiddenInput.value = `${variant_id}:0`;
      input.value = 0;
      input.dataset.oldValue = '0';
      if (accessories_input) accessories_input.value = 0;
    }

    this.syncQtyButtonStateForInput(input);
    this.recalculateAdditionalPrice();
    this.updateTotalPrice();
  }

  initQtyButtons() {
    const scope = this.productScope();
    if (scope.dataset.qtyButtonsBound === 'true') return;
    scope.dataset.qtyButtonsBound = 'true';
    scope.addEventListener('click', (event) => {
      const button = event.target.closest('.btn-number');
      if (!button || !scope.contains(button)) return;
      event.preventDefault();
      this.handleQtyButtonClick(button);
    });
  }

  syncPdpAddonHiddenInput(visibleInput) {
    if (!visibleInput?.name?.startsWith('properties[_pdp_addon_')) return;

    const qty = parseInt(visibleInput.value, 10) || 0;
    const variantId = visibleInput.dataset.variant;
    const form = this.productForm();
    const hiddenInput = form?.querySelector(`input[type="hidden"][name="${visibleInput.name}"]`);
    if (hiddenInput && variantId) {
      hiddenInput.value = `${variantId}:${qty}`;
    }
    const handle = visibleInput.dataset.handle;
    if (handle) {
      const accessoriesInput = form?.querySelector(`input[name="properties[Accessories][${handle}]"]`);
      if (accessoriesInput) accessoriesInput.value = qty;
    }
  }

  initInputNumberFields() {
    const scope = this.productScope();
    if (scope.dataset.inputNumberBound === 'true') return;
    scope.dataset.inputNumberBound = 'true';

    scope.addEventListener('focusin', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('input-number')) return;
      input.dataset.oldValue = input.value;
    });

    scope.addEventListener('keyup', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('input-number')) return;
      const minValue = parseInt(input.getAttribute('min'), 10);
      const maxValue = parseInt(input.getAttribute('max'), 10);
      const valueCurrent = parseInt(input.value, 10);

      if (valueCurrent < minValue || valueCurrent > maxValue) {
        input.value = input.dataset.oldValue;
      }

      this.syncQtyButtonStateForInput(input);
    });

    scope.addEventListener('input', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('input-number')) return;
      this.syncQtyButtonStateForInput(input);
      this.syncPdpAddonHiddenInput(input);
      this.recalculateAdditionalPrice();
      this.updateTotalPrice();
    });

    scope.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('input-number')) return;

      const minValue = parseInt(input.getAttribute('min'), 10);
      const maxValue = parseInt(input.getAttribute('max'), 10);
      let valueCurrent = parseInt(input.value, 10);

      if (isNaN(valueCurrent)) {
        valueCurrent = minValue;
        input.value = minValue;
      }

      if (valueCurrent < minValue) {
        input.value = minValue;
        valueCurrent = minValue;
      } else if (valueCurrent > maxValue) {
        input.value = input.dataset.oldValue ?? maxValue;
        valueCurrent = parseInt(input.value, 10);
      }

      input.dataset.oldValue = String(valueCurrent);
      this.syncQtyButtonStateForInput(input);
      this.syncPdpAddonHiddenInput(input);
      this.recalculateAdditionalPrice();
      this.updateTotalPrice();
    });
  }

  initOptionToggles() {
    const scope = this.productScope();
    if (scope.dataset.optionTogglesBound === 'true') return;
    scope.dataset.optionTogglesBound = 'true';

    const syncToggle = (toggle) => {
      if (!(toggle instanceof HTMLInputElement)) return;
      if (!toggle.matches('.switch input[type="checkbox"]')) return;
      this.updateInputs(toggle);
    };

    scope.addEventListener('change', (event) => {
      const toggle = event.target;
      if (!(toggle instanceof HTMLInputElement)) return;
      if (!toggle.matches('.switch input[type="checkbox"]')) return;
      syncToggle(toggle);
    });

    // Apply initial checked state (e.g. addon toggle starts on)
    setTimeout(() => {
      scope.querySelectorAll('.switch input[type="checkbox"]').forEach((toggle) => {
        if (toggle.checked) syncToggle(toggle);
      });
    }, 100);
  }

  initOptionWrappers() {
    const toggles = document.querySelectorAll('.switch input[type="checkbox"]');
    const wrappers = Array.from(toggles).map(toggle =>
      toggle.closest('.switch-wrapper')?.nextElementSibling
    );

    wrappers.forEach(wrapper => {
      const options = wrapper?.querySelectorAll('.product-option-selector') || null;
      if (options) {
        options.forEach(option => {
          const siblings = this.getSiblings(option);
          option.addEventListener('click', () => {
            siblings.forEach(sibling => sibling.classList.remove('checked'));
            option.classList.toggle('checked');
            const customizationComponent = wrapper.closest('.product__info-wrapper')?.querySelector('customization-product');
            if (customizationComponent?.setFormInput) {
              customizationComponent.setFormInput(option);
            }
          });
        });
      }
    });
  }

  initLineItemInputs() {
    const syncNamedFieldToForm = (input) => {
      const name = input.name;
      if (!name) return;
      const value = input.value;
      const field = input.closest('.line-item-property__field');
      const chars = field?.querySelector('.char-size');
      const scope = input.closest('.product') || document;
      const form = scope.querySelector('product-form form.form');
      const productprop = form
        ? Array.from(form.querySelectorAll('input.additional_input_field, input[type="hidden"]')).find(
            (el) => el !== input && el.name === name.trim() && !el.dataset.addonHandle
          )
        : null;
      if (productprop && productprop.type !== 'file') productprop.value = value;
      if (chars && input.hasAttribute('maxlength')) {
        chars.innerHTML = parseInt(input.getAttribute('maxlength')) - value.length;
      }
    };

    document.querySelectorAll('.line-item-property__field input, .line-item-property__field textarea').forEach(input => {
      if (isRequiredNumberPropertyInput(input)) {
        input.inputMode = 'numeric';
        input.pattern = '[0-9]*';
        input.setAttribute('data-numeric-only', '');
        input.addEventListener('beforeinput', (event) => {
          if (event.isComposing || !event.data) return;
          const normalized = lineItemDigitsOnly(event.data);
          if (normalized === event.data) return;
          event.preventDefault();
          if (!normalized) return;

          const start = input.selectionStart ?? input.value.length;
          const end = input.selectionEnd ?? start;
          const max = input.maxLength > 0 ? input.maxLength : Infinity;
          const room = max - (input.value.length - (end - start));
          if (room <= 0) return;
          const insert = normalized.slice(0, room);
          input.value = input.value.slice(0, start) + insert + input.value.slice(end);
          const caret = start + insert.length;
          if (typeof input.setSelectionRange === 'function') input.setSelectionRange(caret, caret);
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }

      input.addEventListener('keyup', () => {
        if (input.hasAttribute('data-numeric-only')) restrictLineItemInputToDigits(input);
        syncNamedFieldToForm(input);
      });
      input.addEventListener('input', () => {
        if (input.hasAttribute('data-numeric-only')) restrictLineItemInputToDigits(input);
        syncNamedFieldToForm(input);
        if (input.type === 'file' || !input.value.trim()) return;
        input.closest('.line-item-property__field')?.querySelectorAll('.error').forEach((errorEl) => {
          errorEl.classList.add('hidden');
        });
      });
    });

    document.querySelectorAll('.line-item-property__field select').forEach((select) => {
      select.addEventListener('change', () => {
        syncNamedFieldToForm(select);
        const errorEl = select.closest('.line-item-property__field')?.querySelector('.error');
        if (errorEl && select.value) errorEl.classList.add('hidden');
      });
    });

    document.querySelectorAll('.line-item-property__field button.select_file').forEach(button => {
      if (button.dataset.uploadBound === 'true') return;
      button.dataset.uploadBound = 'true';

      const name = button.dataset.name;
      if (!name) return;

      const associatedEl = button.closest(`[data-for^=field-for-]`);
      if (!associatedEl) return;

      const form =
        button.closest('product-form')?.querySelector('form.form') ||
        document.querySelector('.product-form form.form');
      if (!form) return;

      // Addon file inputs are rendered before the main product ones and can share
      // the same name — prefer the input that matches this button's limit.
      const candidates = Array.from(
        form.querySelectorAll('input.additional_input_field[type="file"]')
      ).filter((el) => el.name === name.trim());
      const buttonLimit = button.dataset.fileLimit;
      const input =
        candidates.find((el) => el.dataset.fileLimit === buttonLimit) ||
        candidates[candidates.length - 1];
      if (!input) return;

      const maxFiles = Math.max(
        1,
        parseInt(
          button.dataset.fileLimit ||
            button.closest('[data-file-limit]')?.dataset.fileLimit ||
            input.dataset.fileLimit,
          10
        ) || 1
      );
      input.dataset.fileLimit = String(maxFiles);
      // Form input keeps accumulated files for submit (needs multiple when limit > 1).
      if (maxFiles > 1) input.setAttribute('multiple', '');
      else input.removeAttribute('multiple');

      const previewList = associatedEl.querySelector('.file-upload-photo__list');
      const selectedFiles = new DataTransfer();

      const isSameFile = (a, b) =>
        a.name === b.name && a.size === b.size && a.lastModified === b.lastModified;

      const syncInputFiles = () => {
        if (maxFiles > 1) input.setAttribute('multiple', '');
        input.files = selectedFiles.files;
      };

      const limitLabel = associatedEl.querySelector('.file-limit-label');

      const updateAddButton = () => {
        const atLimit = selectedFiles.files.length >= maxFiles;
        button.classList.toggle('is-at-limit', atLimit);
        if (atLimit) button.setAttribute('disabled', 'disabled');
        else button.removeAttribute('disabled');
        if (limitLabel) limitLabel.classList.toggle('hidden', atLimit);
      };

      const setErrorVisible = (visible) => {
        const errorEl = associatedEl.querySelector('.error');
        if (!errorEl) return;
        errorEl.classList.toggle('hidden', !visible);
      };

      const renderPreviews = () => {
        if (previewList) {
          previewList.querySelectorAll('img[data-object-url]').forEach((img) => {
            if (img.dataset.objectUrl) URL.revokeObjectURL(img.dataset.objectUrl);
          });
          previewList.innerHTML = '';

          Array.from(selectedFiles.files).forEach((file, index) => {
            const tile = document.createElement('div');
            tile.className = 'file-upload-photo preview-container';

            const img = document.createElement('img');
            img.className = 'file-upload-photo__image';
            img.alt = 'Uploaded photo preview';
            const objectUrl = URL.createObjectURL(file);
            img.dataset.objectUrl = objectUrl;
            img.src = objectUrl;

            const removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'file-upload-photo__remove';
            removeBtn.setAttribute('aria-label', 'Remove photo');
            removeBtn.dataset.index = String(index);
            removeBtn.innerHTML =
              '<svg width="14" height="14" viewBox="0 0 14 14" class="icon icon-close" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
              '<path d="M1 1L12.9997 12.9997" stroke="#3A0606" stroke-width="1.5" stroke-linecap="round"></path>' +
              '<path d="M13.0005 1.00024L1.00083 12.9999" stroke="#3A0606" stroke-width="1.5" stroke-linecap="round"></path>' +
              '</svg>';

            tile.appendChild(img);
            tile.appendChild(removeBtn);
            previewList.appendChild(tile);
          });

          previewList.classList.toggle('is-empty', selectedFiles.files.length === 0);
        }

        updateAddButton();
      };

      const setSelectedFiles = (files) => {
        const capped = Array.from(files || []).slice(0, maxFiles);
        while (selectedFiles.items.length > 0) selectedFiles.items.remove(0);
        capped.forEach((file) => selectedFiles.items.add(file));
        syncInputFiles();
        renderPreviews();
      };

      const addIncomingFiles = (incomingFiles) => {
        const incoming = Array.from(incomingFiles || []);
        if (!incoming.length) return;

        const existing = Array.from(selectedFiles.files);
        const remaining = Math.max(0, maxFiles - existing.length);
        const uniqueIncoming = [];

        incoming.forEach((file) => {
          const duplicate =
            existing.some((current) => isSameFile(current, file)) ||
            uniqueIncoming.some((current) => isSameFile(current, file));
          if (!duplicate) uniqueIncoming.push(file);
        });

        const accepted = uniqueIncoming.slice(0, remaining);
        const overflow = uniqueIncoming.length > remaining;
        setSelectedFiles(existing.concat(accepted));
        setErrorVisible(overflow);
      };

      const removeFileAt = (index) => {
        const next = Array.from(selectedFiles.files).filter((_, i) => i !== index);
        setSelectedFiles(next);
        setErrorVisible(false);
      };

      if (previewList) {
        previewList.addEventListener('click', (event) => {
          const removeBtn = event.target.closest('.file-upload-photo__remove');
          if (!removeBtn) return;
          event.preventDefault();
          removeFileAt(parseInt(removeBtn.dataset.index, 10));
        });
      }

      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (selectedFiles.files.length >= maxFiles) return;

        // Separate single-file picker so the OS dialog cannot multi-select,
        // while the real form input still stores all accumulated files.
        const picker = document.createElement('input');
        picker.type = 'file';
        picker.accept = input.getAttribute('accept') || 'image/*';
        picker.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;';
        document.body.appendChild(picker);

        let settled = false;
        const cleanup = () => {
          if (settled) return;
          settled = true;
          window.removeEventListener('focus', onWindowFocus);
          picker.remove();
        };

        const onWindowFocus = () => {
          // Cancelled dialogs skip `change`; clean up on return to the page.
          window.setTimeout(() => {
            if (!picker.files?.length) cleanup();
          }, 300);
        };

        picker.addEventListener(
          'change',
          () => {
            addIncomingFiles(picker.files);
            cleanup();
          },
          { once: true }
        );

        window.addEventListener('focus', onWindowFocus);
        picker.click();
      });

      updateAddButton();
    });
  }

  initGenderSelector() {
    const propSelect = this.querySelector('.genderSelector select');
    if (!propSelect) return;

    const syncGenderToForm = () => {
      const name = propSelect.name;
      const value = propSelect.value;
      const form = this.querySelector('form');
      if (!form) return;

      let productprop = form.querySelector(`[name="${name}"]`);
      if (!productprop) {
        productprop = document.createElement('input');
        productprop.type = 'hidden';
        productprop.name = name;
        form.appendChild(productprop);
      }
      productprop.value = value;
    };

    propSelect.addEventListener('change', syncGenderToForm);
  }
}

customElements.define('customization-product', CustomizationProduct);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}


function ContainsAny(str, items) {
  for (var i in items) {
    var item = items[i];
    if (str.indexOf(item) > -1) {
      return true;
    }

  }
  return false;
}

customElements.define('product-recommendations', ProductRecommendations);

class CustomSelect extends HTMLElement {
  connectedCallback() {
    this.classList.add('select-element-wrapper');
    const name = this.getAttribute('name');
    const placeholder = this.getAttribute('placeholder') || window.formStrings?.selectPlaceholder || 'Select an option';

    // Save the icon (if provided) before clearing innerHTML
    const icon = this.querySelector('.svg-wrapper');
    // Create a hidden input for form submission
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    if (name) hiddenInput.name = name;

    // Parse light DOM options
    const rawOptions = Array.from(this.querySelectorAll('option'));
    const options = rawOptions.map(option => ({
      value: option.value,
      label: option.textContent,
      selected: option.hasAttribute('selected')
    }));

    this.innerHTML = ''; // clear light DOM
    this.appendChild(hiddenInput); // re-append hidden input

    // Create UI
    const selectBox = document.createElement('div');
    selectBox.className = 'select-component';
    selectBox.tabIndex = 0;
    selectBox.textContent = placeholder;

    if (icon) selectBox.appendChild(icon); // Add your custom icon span

    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'custom-options';

    options.forEach(opt => {
      const optEl = document.createElement('div');
      optEl.className = 'custom-option';
      optEl.textContent = opt.label;
      optEl.dataset.value = opt.value;
      optionsContainer.appendChild(optEl);
    });

    this.appendChild(selectBox);
    this.appendChild(optionsContainer);

    // Set initial selected value if any
    const selectedOption = options.find(opt => opt.selected || opt.value === this.getAttribute('value'));
    if (selectedOption) {
      selectBox.textContent = selectedOption.label;
      hiddenInput.value = selectedOption.value;
      this.setAttribute('value', selectedOption.value);
      if (icon) selectBox.appendChild(icon)
    }

    // Event listeners
    selectBox.addEventListener('click', () => {
      this.classList.toggle('open');
    });

    optionsContainer.querySelectorAll('.custom-option').forEach(optEl => {
      optEl.addEventListener('click', () => {
        selectBox.textContent = optEl.textContent;
        selectBox.dataset.value = optEl.dataset.value;
        hiddenInput.value = optEl.dataset.value;
        this.setAttribute('value', optEl.dataset.value);
        if (icon) selectBox.appendChild(icon)
        this.classList.remove('open');

        // Trigger change and input events
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    // Close dropdown on outside click
    window.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.classList.remove('open');
      }
    }, true);
  }

  get value() {
    return this.querySelector('input[type="hidden"]')?.value || '';
  }

  set value(val) {
    const option = this.querySelector(`.custom-option[data-value="${val}"]`);
    const hidden = this.querySelector('input[type="hidden"]');
    const box = this.querySelector('.select-component');
    if (option && hidden && box) {
      hidden.value = val;
      box.textContent = option.textContent;
    }
  }
}

customElements.define('select-element', CustomSelect);

(function () {
  function bindImageWithLoader(container) {
    if (!(container instanceof Element) || !container.classList.contains('image-with-loader')) return;
    if (container.dataset.loaderBound === 'true') return;

    container.dataset.loaderBound = 'true';

    const img = container.querySelector('img');
    if (!img) {
      container.classList.add('image-loaded');
      return;
    }

    const markLoaded = () => container.classList.add('image-loaded');

    if (img.complete) {
      markLoaded();
      return;
    }

    img.addEventListener('load', markLoaded, { once: true });
    img.addEventListener('error', markLoaded, { once: true });
  }

  function initImageWithLoaders(scope = document) {
    const root = scope instanceof Element || scope instanceof Document ? scope : document;
    root.querySelectorAll('.image-with-loader').forEach(bindImageWithLoader);
  }

  initImageWithLoaders();
  document.addEventListener('shopify:section:load', (event) => initImageWithLoaders(event.target));
  window.initImageWithLoaders = initImageWithLoaders;
})();

document.addEventListener('click', (event) => {
  const swatchButton = event.target.closest('.product__swatch-group--card [data-variant-id]');
  if (!swatchButton) return;

  event.preventDefault();
  event.stopPropagation();

  const card = swatchButton.closest('.product-card-wrapper');
  if (!card) return;

  const imageSrc = swatchButton.getAttribute('data-card-image');
  const imageSrcset = swatchButton.getAttribute('data-card-image-srcset');
  const variantUrl = swatchButton.getAttribute('data-variant-url');
  const cardImage = card.querySelector('.card__media img');

  if (imageSrc && cardImage) {
    cardImage.src = imageSrc;
    if (imageSrcset) {
      cardImage.srcset = imageSrcset;
    }
    card.classList.add('card-wrapper--color-preview');
  }

  if (variantUrl) {
    card.querySelectorAll('.card__heading a.full-unstyled-link, .card__media a.link, .card__media-link').forEach((link) => {
      link.href = variantUrl;
    });
  }

  const swatchList = swatchButton.closest('.product__swatch-list');
  if (swatchList) {
    swatchList.querySelectorAll('.product__swatch-item').forEach((item) => {
      item.classList.remove('product__swatch-item--active');
      const button = item.querySelector('[data-variant-id]');
      if (button) {
        button.setAttribute('aria-pressed', 'false');
        button.removeAttribute('aria-current');
      }
    });
  }

  const activeItem = swatchButton.closest('.product__swatch-item');
  if (activeItem) {
    activeItem.classList.add('product__swatch-item--active');
  }
  swatchButton.setAttribute('aria-pressed', 'true');
  swatchButton.setAttribute('aria-current', 'true');
});

document.dispatchEvent(new CustomEvent('twinkle:global-ready'));
